<template>
  <!-- banner图 -->
  <div class="content-box">
    <swiper class="swiper-box" :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="item of bannerList" :key="item.id">
        <!-- <router-link :to="item.url">
          <img class="main-img" :src="item.pic" alt="" />
        </router-link> -->
        <a :href="item.url">
          <img class="main-img" :src="item.pic" alt="" />
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div
        class="swiper-button-prev left common"
        slot="button-prev"
        ref="left"
      ></div>
      <div
        class="swiper-button-next right common"
        slot="button-next"
        ref="right"
      ></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "BannerList",
  props: ["bannerList"],
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // 循环
        loop: true,
        // 每张播放时长3秒，自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplayDisableOnInteraction: false,
        // 滑动速度
        speed: 1000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.swiper.el.onmouseover = () => {
      this.$refs.left.style.display = "block";
      this.$refs.right.style.display = "block";
    };
    this.swiper.el.onmouseout = () => {
      this.$refs.left.style.display = "none";
      this.$refs.right.style.display = "none";
    };
  }
};
</script>

<style lang="stylus" scoped>
.content-box
  min-width 1200px
  margin 0 auto
.swiper-box
  height 450px
  position relative
  width 801px
  .common
    background rgba(0, 0, 0, 0.3)
    &:before
      content ""
      display inline-block
      width 25px
      height 25px
      border-left 2px solid #fff
      border-bottom 2px solid #fff
      transform rotate(45deg)
      position absolute
      top 10px
      left 10px
  .left
    // transform translateX(230px)
  .right
    // transform translateX(-230px)
    &:before
      transform rotate(225deg)
      left -7px
  // img
  //   width 100%
  //   height 100%
  .main-img
    width 801px
    height 100%
    object-fit cover
    position absolute
    left 50%
    transform translateX(-400px)
    z-index 1111
</style>
